module.exports = __webpack_public_path__ + "static/img/ralph.666c7a3b.jpg";